export default "__VITE_ASSET__fVlMMlKw__"